/*--------------------------------------------------------------------------------------------
Program     :  CollapsibleSidebar.js
Description :  Main program for Map and Track CollapsibleSidebar
Date        :  29/08/2024 
Created By  :  Fode
---------------------------------------------------------------------------------------------
TicketNo         Author          Date            ChangeDesc
---------------------------------------------------------------------------------------------
29082024        - Fode     -  29/08/2024        Created
---------------------------------------------------------------------------------------------*/
import React from 'react';
import { Fab, Tooltip } from '@mui/material';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import MenuOpenIcon from '@mui/icons-material/MenuOpen';

const CollapsibleSidebar = ({ children, isOpen, onToggle, side }) => {
  const containerStyle = {
    position: 'relative',
    height: '100%',
    width: isOpen ? '20%' : '0',
    transition: 'width 300ms ease-in-out',
    overflow: 'visible', // Changed from 'hidden' to 'visible'
  };

  const sidebarStyle = {
    height: '100%',
    width: '100%',
    backgroundColor: '#f3f4f6',
    borderRight: side === 'left' ? '1px solid #d1d5db' : 'none',
    borderLeft: side === 'right' ? '1px solid #d1d5db' : 'none',
    overflow: 'hidden',
  };

  const toggleButtonStyle = {
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
    [side]: isOpen ? 'calc(100% - 28px)' : '-28px',
    transition: `${side} 300ms ease-in-out`,
    zIndex: 1200, // Increased z-index to ensure it's above other elements
  };

  return (
    <div style={containerStyle}>
      <div style={sidebarStyle}>
        {children}
      </div>
      <Tooltip title={isOpen ? "Collapse sidebar" : "Expand sidebar"} placement={side === 'left' ? 'right' : 'left'}>
        <Fab
          color="primary"
          size="small"
          onClick={onToggle}
          style={toggleButtonStyle}
        >
          {isOpen 
            ? (side === 'left' ? <ChevronLeftIcon /> : <ChevronRightIcon />)
            : <MenuOpenIcon />
          }
        </Fab>
      </Tooltip>
    </div>
);
};

export default CollapsibleSidebar;